import DoctorNotes from './DoctorNotes'
export default DoctorNotes
